/** "Showing 26–50 of 112 sessions" with Previous / Next, under a directory table. */
export function Pager({
  first,
  shown,
  total,
  noun,
  page,
  pageCount,
  onPage,
  pageSize,
  pageSizes,
  onPageSize,
}: {
  first: number;
  shown: number;
  total: number;
  noun: string;
  page: number;
  pageCount: number;
  onPage: (page: number) => void;
  /** Given all three, a "Rows per page" choice sits beside the count. */
  pageSize?: number;
  pageSizes?: number[];
  onPageSize?: (size: number) => void;
}) {
  return (
    <div className="flex flex-wrap items-center justify-between gap-3 text-xs text-gray-600">
      <div className="flex flex-wrap items-center gap-4">
        <span>
          Showing{" "}
          <strong className="font-semibold text-gray-900">
            {first}–{first + shown - 1}
          </strong>{" "}
          of <strong className="font-semibold text-gray-900">{total}</strong> {noun}
        </span>
        {pageSize && pageSizes && onPageSize && (
          <label className="inline-flex items-center gap-1.5">
            Rows per page
            <select
              value={pageSize}
              onChange={(event) => onPageSize(Number(event.target.value))}
              className="h-7 rounded border border-gray-300 bg-white px-1.5 text-xs"
            >
              {pageSizes.map((size) => (
                <option key={size} value={size}>
                  {size}
                </option>
              ))}
            </select>
          </label>
        )}
      </div>
      <div className="flex items-center gap-2">
        <button type="button" className="pager-button" disabled={page <= 1} onClick={() => onPage(page - 1)}>
          Previous
        </button>
        <span>
          Page {page} of {pageCount}
        </span>
        <button type="button" className="pager-button" disabled={page >= pageCount} onClick={() => onPage(page + 1)}>
          Next
        </button>
      </div>
    </div>
  );
}

/** One page of rows, plus what the Pager needs to describe it. */
export function paginate<T>(rows: T[], page: number, pageSize: number) {
  const pageCount = Math.max(1, Math.ceil(rows.length / pageSize));
  const current = Math.min(Math.max(page, 1), pageCount);
  return {
    rows: rows.slice((current - 1) * pageSize, current * pageSize),
    first: rows.length ? (current - 1) * pageSize + 1 : 0,
    page: current,
    pageCount,
  };
}
